export default __webpack_public_path__ + "static/media/gallery-wip-emitter_02.927b3cf1.jpg";